<template>
  <div :class="classRoot">
    <button
      class="site-header-mobile__backdrop"
      @click="toggleMenu"
    />

    <div class="container site-header-mobile__container">
      <div class="site-header-mobile__bar">
        <a
          :href="urlHome"
          class="site-header-mobile__logo"
        >
          <AvainLogoIcon />
        </a>

        <div class="site-header-mobile__controls print-hide">

          <FavouritesDropdown>
            <div :class="['site-header-mobile__control', {'site-header-mobile__control--behind': menuOpen}]">
              <div class="site-header-mobile__favourite-toggle">
                <MobileMenuApplicationIcon />
                <div
                  v-if="favouritesRental.length"
                  class="favourites-dropdown__default-toggle-count favourites-dropdown__default-toggle-count--rental"
                  :class="(favouritesRental.length > 0 && favouritesASO.length > 0) ? 'favourites-dropdown__default-toggle-count---twoBallsVisible' : ''"
                >
                  {{favouritesRental.length}}
                </div>
                <div
                  v-if="favouritesASO.length"
                  class="favourites-dropdown__default-toggle-count favourites-dropdown__default-toggle-count--ASO"
                  :class="(favouritesRental.length > 0 && favouritesASO.length > 0) ? 'favourites-dropdown__default-toggle-count---twoBallsVisible' : ''"
                >
                  {{favouritesASO.length}}
                </div>
              </div>
            </div>
          </FavouritesDropdown>

          <SearchDropdown>
            <div :class="['site-header-mobile__control', {'site-header-mobile__control--behind': menuOpen}]">
              <MobileMenuSearchIcon />
            </div>
          </SearchDropdown>


          <button
            class="site-header-mobile__control"
            @click="toggleMenu"
          >
            <MobileMenuXIcon v-if="menuOpen"/>
            <MobileMenuHamburgerIcon v-else/>
          </button>
        </div>
      </div>
    </div>

    <div class="site-header-mobile__drawer">
      <div class="container">
        <div class="site-header-mobile__drawer-content">
          <div class="site-header-mobile__menu-primary link-list">
            <ul class="link-list__list">
              <li
                v-for="item in this.menu"
                :key="item.title"
                class="bottom-border"
              >
              <div class="link-with-icon">
                <a
                  :href="item.url"
                  :target="item.target"
                >
                  {{ item.title }}
                 <!--<ArrowIcon class="link-with-icon__icon" /> -->
                </a>
                <button
                  class="submenu__control"
                  v-if="item.submenu.length"
                  @click="item.submenuOpen = !item.submenuOpen"
                >
                 <ChevronIcon
                  class="submenu__control-icon"
                  :class="{'submenu__control-icon--close': item.submenuOpen}"
                />
                </button>
                </div>
                <template v-if="item.submenu.length && item.submenuOpen">
                  <ul class="submenu__list submenu">
                    <li
                      v-for="subitem in item.submenu"
                      :key="subitem.title">
                      <a
                        :href="subitem.url"
                        :target="subitem.target"
                        class="submenu-link"
                      >{{ subitem.title }}</a>
                    </li>
                  </ul>
                </template>

              </li>
            </ul>
          </div>

          <ul class="site-header-mobile__menu-secondary">
            <li
              v-for="item in menuSecondary"
              :key="item.title"
              class="site-header-mobile__menu-secondary-item"
            >
              <a
                :href="item.url"
                :target="item.target"
                class="site-header-mobile__menu-secondary-link"
              >
                {{ item.title }}
              </a>
            </li>
            <li
              v-for="item in languageSwitcher"
              :key="item.title"
              class="site-header-mobile__menu-secondary-item"
            >
              <a
                :href="item.url"
                class="site-header-mobile__menu-secondary-link"
              >
                {{ item.name }}
              </a>
            </li>
          </ul>
        </div>

      <div class="top-block"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  import globals from '../lib/globals';
  import FavouritesDropdown from './FavouritesDropdown';
  import SearchDropdown from './SearchDropdown';
  import AvainLogoIcon from './icons/AvainLogoIcon';
  import MobileMenuApplicationIcon from "./icons/MobileMenuApplicationIcon";
  import MobileMenuHamburgerIcon from "./icons/MobileMenuHamburgerIcon";
  import MobileMenuSearchIcon from "./icons/MobileMenuSearchIcon";
  import MobileMenuXIcon from "./icons/MobileMenuXIcon";
  import ArrowIcon from './icons/ArrowIcon.vue';
  import ChevronIcon from './icons/ChevronIcon';

  export default {
    components: {
    MobileMenuHamburgerIcon,
    MobileMenuApplicationIcon,
    MobileMenuSearchIcon,
    MobileMenuXIcon,
    AvainLogoIcon,
    SearchDropdown,
    FavouritesDropdown,
    ArrowIcon,
    ChevronIcon
},
    props: {
      menuPrimary: {
        type: Array,
        required: true,
      },
      menuSecondary: {
        type: Array,
        required: true,
      },
      languageSwitcher: {
        type: [Object, Array], // Array is valid only if it's empty
        required: true,
      },
      minimal: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        top: true,
        menuOpen: false,
        urlHome: globals.urlHome,
        menu: [],
        vh: 0,
      }
    },
    computed: {
      ...mapGetters(['favouritesAll', 'favouritesRental', 'favouritesASO']),
      classRoot() {
        return ['site-header-mobile', {
          'site-header-mobile--menu-open': this.menuOpen,
          'site-header-mobile--minimal': this.minimal,
          'site-header-mobile--top': this.top,
        }];
      }
    },
    methods: {
      toggleMenu() {
        this.menuOpen = !this.menuOpen;
        this.menuOpen ? document.body.classList.add("mobile-menu-open") : document.body.classList.remove("mobile-menu-open");

      },
      updateTop() {
        this.top = window.scrollY === 0;
      },
      calculateVh() {
        this.vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', this.vh + 'px');
      },
    },
    beforeMount() {
      // Note that these event listener are never removed
      window.addEventListener('scroll', this.updateTop);
      window.addEventListener('resize', this.calculateVh);
      window.addEventListener('orientationchange', this.calculateVh);
    },
    mounted() {
      this.updateTop();
      this.calculateVh();
      const menu = this.menuPrimary
        .filter(item => item.menu_item_parent == "0")
        .map(item => {
          return {
            id: item.ID,
            title: item.title,
            target: item.target,
            url: item.url,
            order: item.menu_order,
            submenu: [],
            submenuOpen: false,
          }
      });

      this.menuPrimary.forEach(item => {
        const menuParentId = parseInt(item.menu_item_parent);
        if(menuParentId > 0) {
          const index = menu.findIndex((x) => x.id === menuParentId)
          const obj = {
            id: item.ID,
            title: item.title,
            target: item.target,
            url: item.url,
            order: item.menu_order,
          }
          menu[index].submenu.push(obj);
        }
      });

     this.menu = menu;
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .mobile-menu-open {
    @include media-breakpoint-down(sm) {
      overflow: hidden;
    }
  }

  .top-block {
    height: $site-header-mobile__height;
    background-color: #3a899f;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }

  .site-header-mobile {
    position: fixed;
    z-index: 100;
    width: 100%;
    //transition: background-color 0.2s;
    background-color: rgba($color-black, 1);

    &--top {
      //background-color: rgba($color-black, 0.5);
    }

    @media print {
      position: absolute;
      background-color: transparent;
    }
  }

  .site-header-mobile__backdrop {
    @include reset-button;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: #000;
    visibility: hidden;
    transition: opacity 0.2s, visibility 0.2s;

    .site-header-mobile--menu-open & {
      visibility: visible;
      opacity: 0.5;
    }
  }

  .site-header-mobile__container {
  }

  .site-header-mobile__bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: $site-header-mobile__height;
    //transition: height 0.2s;

    .site-header-mobile--top & {
      height: $site-header-mobile__height;
    }
  }

  .site-header-mobile__logo {
    @include font-h-22;
    z-index: 1;
    color: $color-white;

    svg {
      width: r(70);
      height: r(calc(70 / $avain-logo-aspect-ratio));
    }
  }

  .site-header-mobile__controls {
    display: flex;
    margin: 0 r(-8);

    .site-header-mobile--minimal & {
      display: none;
    }
  }

  .site-header-mobile__control {
    @include reset-button;
    color: $color-white;
    z-index: 1;
    margin: 0 r(8);

    &--behind {
      z-index: 0;
    }
  }

  .submenu__control {
    @include reset-button;
    color: $color-white;

    .submenu__control-icon {
      transition: transform 0.2s;

      &--close {
        transform: rotate(180deg);
      }
    }
  }

  .submenu.submenu__list {
    @include reset-list();
    margin-bottom: 1rem;
  }

  .site-header-mobile__favourite-toggle {
    position: relative;
  }

  .submenu-link {
    @include font-label-14;
    display: flex;
    padding: r(8) 0;
    color: $color-white;
  }

  .site-header-mobile__menu-primary .link-with-icon {
    border-bottom: none;
    color: $color-white;
  }

  .bottom-border {
    border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.4);
  }

  .site-header-mobile__favourite-toggle-count {
    @include font-body-10();
    position: absolute;
    display: flex;
    top: r(16);
    right: r(-2);
    width: r(17);
    height: r(17);
    align-items: center;
    justify-content: center;
    background-color: $color-pink;
    border-radius: 50%;
    color: $color-white;
  }

  .site-header-mobile__drawer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(var(--vh) * 100);
    padding: $site-header-mobile__height 0 r(88);
    background-image: linear-gradient(0deg, $color-blue-dirty-light, $color-blue-dirty);
    background-position: 0 $site-header-mobile__height;
    transform: translateX(-100%);
    transition: transform 0.2s;
    overflow-x: hidden;

    .site-header-mobile--menu-open & {
      transform: none;
    }
  }

  .site-header-mobile__drawer-content {
    margin: 0 auto;
    padding: 0 r(40);
  }

  .site-header-mobile__menu-primary {
    margin-bottom: r(48);
  }

  .site-header-mobile__menu-secondary {
    @include reset-list;
  }

  .site-header-mobile__menu-secondary-item {
    & + & {
      margin-top: r(20);
    }
  }

  .site-header-mobile__menu-secondary-link {
    font-size: r(12);
    text-transform: uppercase;
    color: $color-white;
  }
</style>
